import { routing } from "@/i18n/routing";

/**
 * Public site origin (no trailing slash). CRA reads REACT_APP_*; NEXT_PUBLIC_* kept for parity.
 */
export const SITE_URL = (
  (typeof process !== "undefined" && process.env?.REACT_APP_SITE_URL) ||
  (typeof process !== "undefined" && process.env?.NEXT_PUBLIC_SITE_URL) ||
  "https://highlandgroup.ch"
).replace(/\/$/, "");

/** First path segment must be a supported locale for canonicals and sitemap. */
export function normalizeLocale(raw) {
  const l =
    raw == null || raw === ""
      ? routing.defaultLocale
      : Array.isArray(raw)
        ? String(raw[0])
        : String(raw);
  return routing.locales.includes(l) ? l : routing.defaultLocale;
}

/** Absolute URL: https://highlandgroup.ch/{locale}/...segments */
export function sitePageUrl(locale, ...segments) {
  const loc = normalizeLocale(locale);
  const rest = segments
    .filter((s) => s != null && s !== "")
    .map((s) => String(s).replace(/^\/+|\/+$/g, ""))
    .filter(Boolean)
    .join("/");
  return rest ? `${SITE_URL}/${loc}/${rest}` : `${SITE_URL}/${loc}`;
}

export function ogLocaleTag(locale) {
  const l = normalizeLocale(locale);
  const map = { en: "en_US", de: "de_DE", fr: "fr_FR", it: "it_IT" };
  return map[l] || `${l}_${l.toUpperCase()}`;
}
